var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2127 1.45897C12.6048 0.84701 11.5105 0.84701 10.8418 1.45897L1.29765 10.5772C0.993691 10.8832 0.872109 11.3727 1.17606 11.8011C1.48002 12.2907 2.08793 12.1071 2.45267 11.8011L2.63505 11.6175V21.0417C2.63505 21.5313 2.81742 21.9597 3.12137 22.3268C3.42533 22.6328 4.03324 22.9388 4.51956 22.9388H9.68679V17.6147C9.68679 17.3088 9.86916 17.0028 9.99075 16.6968C10.1731 16.5132 10.4771 16.3908 10.781 16.3908H13.1519C13.4558 16.3908 13.7598 16.5744 14.0637 16.6968C14.2461 16.8804 14.3677 17.3088 14.3677 17.6147V23H19.6565C20.1428 23 20.5684 22.8164 20.9331 22.5104C21.2371 22.2045 21.4194 21.7149 21.4194 21.2253V11.8011C21.9058 12.1071 22.3313 12.1071 22.696 11.8011C23 11.6175 23 11.3115 23 11.1892C23 11.0056 22.8176 10.6996 22.696 10.5772L13.2127 1.45897Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageBlack);
export default __webpack_public_path__ + "static/media/Home_Page_Black.a840f2578a82c7222e18bf1f0a0b8154.svg";
export { ForwardRef as ReactComponent };